<template></template>
<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "RecordsListener",
  props: {
    collection: String,
    userID: String,
    formID: String
  },
  data() {
    return {
      unsubscribe: null
    };
  },
  mounted() {
    var self = this;
    this.unsubscribe = firebase
      .firestore()
      .collection(self.collection)
      .doc(self.userID)
      .collection("records")
      .where("id", "==", self.formID)
      .onSnapshot(function(querySnapshot) {
        var formsArray = [];
        querySnapshot.forEach(function(doc) {
          var tempDoc = doc.data();
          tempDoc.rowID = doc.id;
          formsArray.push(tempDoc);
        });
        self.$emit("records-real-time", formsArray);
      });
  },
  destroyed() {
    this.unsubscribe();
    this.$emit("listener-is-destroyed");
    console.log("se destruye listener con los cambios");
    // destroy connections
  }
};
</script>
